var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center empty-list w-100",style:(`height: ${_vm.size || 50}vh`)},[_c('div',[_c('img',{staticClass:"mb-4",attrs:{"src":require("@/assets/images/empty-box.png"),"alt":"","height":"60"}}),_c('p',[_vm._v(_vm._s(_vm.text || "Não há dados para serem exibidos"))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }